import { createSlice } from "@reduxjs/toolkit";
import {StreamFormat, StreamQuality} from "./StreamSlice";

export interface ILink {
	id: number,
	hash: string,
	owner: 'BB'|'OL',
	format: StreamFormat,
	quality: StreamQuality,
	url: string|null,
	blocked: boolean,
	created_at: string|null,
	updated_at: string|null,
}

export interface LinkState {
	links: ILink[],
	gettingList: boolean,
	deleting: boolean,
	editing: boolean,
	isError: boolean,
	errorCode: number,
	errorMessage: string|null,
}

export const initialState: LinkState = {
	links: [],
	gettingList: false,
	deleting: false,
	editing: false,
	isError: false,
	errorCode: 0,
	errorMessage: null,
};

export const LinkSlice = createSlice({
	name: 'link',
	initialState,
	reducers: {
		onLoadEdit: (state, action): LinkState => {
			return { ...state, editing: true };
		},
		onSuccessEdit: (state, action): LinkState => {
			return { ...state, editing: false };
		},
		onErrorEdit: (state, action): LinkState => {
			return {
				...state,
				editing: false,
				isError: action.payload.isError,
				errorCode: action.payload.errorCode,
				errorMessage: action.payload.errorMessage
			}
		},

		onLoadDelete: (state, action): LinkState => {
			return { ...state, deleting: true };
		},
		onSuccessDelete: (state, action): LinkState => {
			return { ...state, deleting: false };
		},
		onErrorDelete: (state, action): LinkState => {
			return {
				...state,
				deleting: false,
				isError: action.payload.isError,
				errorCode: action.payload.errorCode,
				errorMessage: action.payload.errorMessage
			}
		},

		onLoadSearch: (state, action ): LinkState => {
			return { ...state, gettingList: true, links: [] };
		},
		onSuccessSearch: (state, action): LinkState => {
			return { ...state, gettingList: false, links: action.payload.data.data };
		},
		onErrorSearch: (state, action): LinkState => {
			return {
				...state,
				gettingList: false,
				links: [],
				isError: action.payload.isError,
				errorCode: action.payload.errorCode,
				errorMessage: action.payload.errorMessage
			};
		},
	},
});

export const {

} = LinkSlice.actions;
